import { render, staticRenderFns } from "./ObservedSensorValueExportTable.vue?vue&type=template&id=ab506762&scoped=true"
import script from "./ObservedSensorValueExportTable.vue?vue&type=script&lang=js"
export * from "./ObservedSensorValueExportTable.vue?vue&type=script&lang=js"
import style0 from "./ObservedSensorValueExportTable.vue?vue&type=style&index=0&id=ab506762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab506762",
  null
  
)

export default component.exports